import { compose } from "recompose";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SafeLogoWhite from "../../assets/images/sselogo1(nobackwhite).png";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import ChangePasswordModal from "../ChangePasswordModal";
import { getInitials } from "../../utils";
import constants from "../../config/constant";
import logOutIcons from "../../assets/images/logout-icon.png";

const { ROLE } = constants;
const activeTabObj = {
  "/admin/manage-organizations": 1,
  "/admin/manage-buyers": 2,
  "/admin/manage-realtor": 3
}
class BuyerOrgHeader extends React.Component {
  state = {
    selectedFile: null,
    spin: false,
    open: false,
    passChangeModal: false,
    avatarID: "",
    anchorEl: null,
    currentPath: null
  };
  onDrop = file => {
    if (file && file.target && file.target.files[0]) {
      this.props.onDrop(file);
    }
  };
  handleMenu = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  openChangePassModal = () => {
    this.props.dispatch({ type: "CHANGE_PASSWORD", payload: true });
    // this.setState({ passChangeModal: true }, ()=> console.log('test ', this.changePassword));
    this.handleClose();
  };

  doLogout = () => {
    this.props.dispatch({ type: "LOGOUT" });
    localStorage.clear();
  };

  componentDidMount() {
    const currentPath = activeTabObj[this.props.match.path];
    const { authentication } = this.props;
    const { authenticatedUser } = authentication;
    const { avatar } = authenticatedUser;
    const avatarID =
      typeof avatar === "string" &&
        avatar.length > 0 &&
        JSON.parse(avatar) &&
        JSON.parse(avatar).public_id &&
        JSON.parse(avatar).public_id !== ""
        ? JSON.parse(avatar).public_id
        : "";
    this.setState({ avatarID: avatarID, currentPath });
  }

  render() {
    const { classes, authentication } = this.props;
    const { authenticatedUser } = authentication;
    const { first_name, last_name, owner_name, role } = authenticatedUser;
    let fullName = ''
    if (!first_name && !last_name) fullName = owner_name;
    else fullName = first_name + ' ' + last_name;
    return (
      <div>
        <ChangePasswordModal
          ref={changePassword => (this.changePassword = changePassword)}
        />

        <header className={classes.header}>
          <Grid className={classes.headerContainer}>
            <img
              src={SafeLogoWhite}
              alt="safe"
              className={classes.brandImage}
            />
            <div className={classes.dropdownMenu}>
              {role && role === ROLE.ADMIN && (
                <div className={classes.adminMenu}>
                  <Link
                    to="/admin/manage-organizations"
                    className={this.state.currentPath === 1 ? [
                      classes.adminMenuLink,
                      classes.activeMenuLink
                    ].join(" ") : classes.adminMenuLink}
                  >
                    {" "}
                    Manage Organizations
                  </Link>
                  <Link
                    to="/admin/manage-buyers"
                    className={this.state.currentPath === 2 ? [
                      classes.adminMenuLink,
                      classes.activeMenuLink
                    ].join(" ") : classes.adminMenuLink}
                  >
                    {" "}
                    Manage Buyers
                  </Link>
                  <Link
                    to="/admin/manage-realtor"
                    className={this.state.currentPath === 3 ? [
                      classes.adminMenuLink,
                      classes.activeMenuLink
                    ].join(" ") : classes.adminMenuLink}
                  >
                    {" "}
                    Manage Realtor
                  </Link>
                </div>
              )}
              <div className={classes.circle}>
                {getInitials(fullName || '')}
              </div>
              <span className={classes.userName}>
                {fullName}
              </span>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={this.handleMenu}
                color="inherit"
              >
                <ExpandMoreIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                className={classes.menuDropdown}
                anchorEl={this.state.anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                open={this.state.open}
                onClose={this.handleClose}
              >
                {role && role === ROLE.BUYER && (
                  <MenuItem onClick={this.openChangePassModal}>
                    Change Password
                  </MenuItem>
                )}
                <MenuItem onClick={this.doLogout} className={classes.LogoutTab}>
                  <img
                    src={logOutIcons}
                    alt="Logout Icon"
                    onClick={() => this.props.history.goBack()}
                  />
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </Grid>
        </header>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    updatingUser: state.users.updatingUser
  };
};

export default withRouter(compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(BuyerOrgHeader));
